import {
  getActiveBackendSource,
  hasLocalBackendBootstrapFailure,
  isBackendSourceToggleAvailable
} from "@/lib/backendSource";

export function configurationShouldUseLocalBackend() {
  return (
    isBackendSourceToggleAvailable() && getActiveBackendSource() === "shared-dev" && !hasLocalBackendBootstrapFailure()
  );
}

export function shouldSwitchConfigurationToLocalBackend() {
  if (import.meta.env.VITEST) {
    return false;
  }

  return configurationShouldUseLocalBackend();
}
